<template>
  <form v-if="form">
    <div class="flex flex-wrap">
      <div class="p-2" :class="[form.fields.length > 1 ? 'w-1/2' : 'w-full']">
        <VInput
          v-for="(input, i) of form.fields"
          :key="i"
          :placeholder="input.placeholder"
          :name="input.label"
          v-model="input.value"
        />
      </div>
    </div>
    <div class="flex justify-end">
      <button
        class="modal-btn text-sm"
        :class="item.type.style"
        v-for="(item, i) of form.buttons"
        :key="i"
        type="button"
        @click="onClick(item)"
      >{{item.name}}</button>
    </div>
  </form>
</template>

<script>
export default {
  name: "VForm",
  props: {
    form: { default: null }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClick(item) {
      this.$emit(`on${item.name}`, { button: item, values: this.form.values() });
    }
  }
};
</script>

<style>
.modal-btn {
  padding: 8px 10px;
  outline: none;
  min-width: 5rem;
}

.modal-btn:focus {
  outline: none;
}

.modal-btn.primary {
  color: rgb(50, 117, 189);
}
.modal-btn.primary:hover {
  font-weight: bold;
  color: rgb(50, 117, 189);
}

.modal-btn.cancel {
  color: rgb(131, 131, 131);
}
.modal-btn.cancel:hover {
  font-weight: bold;
  color: rgb(131, 131, 131);
}

.modal-btn.danger {
  color: rgb(155, 37, 37);
}
.modal-btn.danger:hover {
  font-weight: bold;
  color: rgb(212, 25, 25);
}
</style>